export function fmtHours(h) {
  const total = Math.round((h || 0) * 60);
  const hh = Math.floor(total / 60);
  const mm = total % 60;
  return `${hh}h ${String(mm).padStart(2, "0")}`;
}

export function fmtTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("fr-CA", { hour: "2-digit", minute: "2-digit" });
}

export function fmtDate(iso) {
  return new Date(iso + "T00:00:00").toLocaleDateString("fr-CA", {
    weekday: "long",
    day: "numeric",
    month: "short",
  });
}

export const DAY_SHORT = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

// Monday-based ISO date for the week containing `d` (Date), offset in weeks
export function weekMonday(offset = 0) {
  const d = new Date();
  d.setDate(d.getDate() + offset * 7);
  const day = (d.getDay() + 6) % 7; // 0 = Monday
  d.setDate(d.getDate() - day);
  return d.toISOString().slice(0, 10);
}

export function weekRangeLabel(startIso) {
  const start = new Date(startIso + "T00:00:00");
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  const opt = { day: "numeric", month: "short" };
  return `${start.toLocaleDateString("fr-CA", opt)} – ${end.toLocaleDateString("fr-CA", opt)}`;
}
